import React from 'react';
import { t } from 'Locale';
import { withStore } from 'Store';
import storeActions from 'Store/storeActions';
import { isTMCZEnv } from 'Options';
import Button from '../Button';
import { styles, buttonStyle } from './WebCookieConsent.jss';

const WebCookieInfo = ({
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    children,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    deviceStorageState,
    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line react/prop-types
    deviceStorageDispatch
}) => {
    const apiText = t('COMMON.COOKIE_INFO');
    const regexMatches = apiText.match(/<a href="(.*)" target="_blank">([^<]*)<\/a>/);

    if (!regexMatches) {
        return <>{children}</>;
    }

    // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
    // eslint-disable-next-line no-unused-vars
    const [_, url, linkTranslation] = regexMatches;
    const infoTranslation = apiText.slice(0, regexMatches.index);

    const giveConsent = () => {
        deviceStorageDispatch({
            type: storeActions.setCookieConsent,
            payload: true
        });
    };

    if (isTMCZEnv) return children;

    return (
        <>
            {!deviceStorageState.cookieConsentGiven && (
                <div style={styles.container}>
                    {infoTranslation}
                    <a style={styles.link} href={url} target="_blank" rel="noopener noreferrer">
                        {linkTranslation}
                    </a>
                    <Button style={buttonStyle} title={t('COMMON.OK')} onPress={giveConsent} />
                </div>
            )}
            {children}
        </>
    );
};

export default withStore(WebCookieInfo);
